export default __webpack_public_path__ + "static/media/setting_mobile.a61abaa7.svg";